import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { CoreApiService } from '../../core-api.service';
import { LoggingService } from '../../logging.service';
import { Acquisition } from '../../shared/models/acquisition.model';

interface DialogData {
  acquisition: Acquisition;
}

@Component({
  host: {
    class: 'mat-dialog-component',
  },
  selector: 'acquisition-notes-dialog',
  templateUrl: './acquisition-notes-dialog.component.html',
  styleUrls: ['./acquisition-notes-dialog.component.scss'],
})
export class AcquisitionNotesDialog {
  acquisition: Acquisition = this.data.acquisition;
  error: Error = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private coreApi: CoreApiService,
    private logger: LoggingService,
    public ref: MatDialogRef<AcquisitionNotesDialog>,
  ) {
    this.getAcquisition();
  }

  getAcquisition(): void {
    this.error = null;
    this.coreApi.acquisitions.get(this.data.acquisition._id).subscribe({
      next: (acquisition: Acquisition) => {
        this.acquisition = acquisition;
      },
      error: (error: HttpErrorResponse) => {
        this.logger.error(error);
        this.error = error;
      },
    });
  }

  close(): void {
    this.ref.close();
  }
}
